import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { getApplicationAuthSource } from './utils/iframeMessaging';
import setApplicationSource from './utils/setApplicationSource';

if (getApplicationAuthSource() === 'retail') {
  /**
       * We need to clear localStorage since both TRUE EJ and native web EJ
       * shares the same namespace for storing auth token. If you remove this remove this
       * 'isValidTokenOrigin' function from Auth.js and iframeMessaging.js
       *  */
  localStorage.clear();
  sessionStorage.clear();
}

setApplicationSource();

ReactDOM.render(<App />, document.getElementById('root'));
